module.exports = __webpack_public_path__ + "img/Cover_HW_22.09c5e7bf.jpg";